import templateUrl from "emun.salesrep/week-activities.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import salesrepConfig from "emun.salesrep/salesrep.config";

class WeekActivitiesController {
  constructor($rootScope) {
    const $ctrl = this;
    basicController($ctrl);
    var timezone = moment.tz.guess();
    this.currentDate = moment.tz(timezone).format("DD/MM/YYYY");
    var dashboardActivityType =
      salesrepConfig.dashboardActivityType || "Store Appointment";
    dashboardActivityType = dashboardActivityType.replace(" ", "%20");
    this.activities = new AutoQuery({
      url:
        "QueryActivitiesJoin.json?typeIn=" +
        dashboardActivityType +
        "&dateRange=Week",
      orderBy: "-StartDate",
      autoLoad: true,
      criteria: {
        currentDate: this.currentDate
      },
      pageSize: 10
    });
    $rootScope.$on("activitySaved", () => $ctrl.activities.load(true));
    $rootScope.$on("activityDeleted", () => $ctrl.activities.load(true));
  }
}

let WeekActivities = {
  bindings: {},
  controller: WeekActivitiesController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};

export default WeekActivities;
